import React from "react";
import PropTypes from "prop-types";

import { Link } from "react-router-dom";

export default function StatsHeader({ userInfo, paramName }) {
  return (
    <div class="row">
      <div class="col-md-12 grid-margin">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-end flex-wrap">
            <div class="mr-md-3 mr-xl-5">
              <h2>
                {paramName
                  ? `${paramName}'s Dashboard`
                  : `Welcome ${
                      userInfo?.FirstName + " " + userInfo?.LastName || ""
                    }
                  `}
              </h2>
              <Link
                to={{
                  pathname: "/dashboard",
                }}
              >
                <div class="d-flex">
                  <i class="mdi mdi-home text-muted hover-cursor"></i>
                  <p class="text-muted mb-0 hover-cursor">
                    &nbsp;/&nbsp;Dashboard&nbsp;
                  </p>
                </div>
              </Link>
            </div>
          </div>
          {/* <div class="d-flex justify-content-between align-items-end flex-wrap">
            <button
              type="button"
              class="btn btn-light bg-white btn-icon mr-3 d-none d-md-block "
            >
              <i class="mdi mdi-download text-muted"></i>
            </button>
            <button
              type="button"
              class="btn btn-light bg-white btn-icon mr-3 mt-2 mt-xl-0"
            >
              <i class="mdi mdi-clock-outline text-muted"></i>
            </button>
            <button
              type="button"
              class="btn btn-light bg-white btn-icon mr-3 mt-2 mt-xl-0"
            >
              <i class="mdi mdi-plus text-muted"></i>
            </button>
            <button class="btn btn-primary mt-2 mt-xl-0">
              Generate report
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
}

StatsHeader.proptTypes = {
  userInfo: PropTypes.object,
  paramName: PropTypes.string,
};
